// @core/api/endpoints/task/create_task.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  CreateTaskRequest,
  TaskResponse,
} from '../../../types/task';

const BASE_PATH = '/task';

/**
 * Create task
 * Creates a new task within a product with the specified title, description, and optional metadata. The caller becomes the task owner.
 */
export async function CreateTask(
  data: CreateTaskRequest,
  options?: RequestOptions
): Promise<TaskResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/tasks`;
  const requestOptions = options;
  return client.post<TaskResponse>(requestPath, data, requestOptions);
}
